<script lang="ts">
	import { page } from '$app/state';
	import { PLAN_TIER } from '#lib/util/billing.ts';
	import type { UserPlan, UserRole } from '#src/types/user.ts';
	import type { Snippet } from 'svelte';

	interface Props {
		children: Snippet;
		fallback?: Snippet;
		minimumRole?: UserRole;
		minimumPlan?: UserPlan;
	}
	let { children, fallback, minimumRole = 'user', minimumPlan = 'free' }: Props = $props();

	// Role hierarchy: user < admin
	const roleHierarchy: Record<UserRole, number> = {
		user: 0,
		admin: 1
	} as const;

	const shouldRender = $derived(() => {
		const userRole = page.data.loggedInUser?.role;
		const userPlan = page.data.loggedInUser?.plan;
		if (!userRole || !userPlan) {
			return false;
		}

		const userRoleLevel = roleHierarchy[userRole] ?? -1;
		const requiredRoleLevel = roleHierarchy[minimumRole] ?? Infinity;

		const userPlanLevel = PLAN_TIER[userPlan] ?? -1;
		const requiredPlanLevel = PLAN_TIER[minimumPlan] ?? Infinity;

		return userRoleLevel >= requiredRoleLevel && userPlanLevel >= requiredPlanLevel;
	});
</script>

{#if shouldRender()}{@render children?.()}{:else}{@render fallback?.()}{/if}
